import React, { useState, useEffect } from 'react'
import { Modal, Form, App, Radio } from 'antd'     
import { useDingdanshouruZFLXMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'
function IncomeFinanceZFLX(props) {
  const { message } = App.useApp()
  const [open, setOpen] = useState(false)
  const [info, setInfo] = useState({
    ddsr_id:props.ddsr_id,
    ddsr_zflx:props.ddsr_zflx,
  })
  const [form] = Form.useForm()
  const [updateSave] = useDingdanshouruZFLXMutation()
  useEffect(() => {
    form.setFieldsValue({
        ddsr_zflx:props.ddsr_zflx,
    })
  }, [props.ddsr_zflx, form])
  return (
    <>
        <Icon type='financeZFLX' onClick={() => setOpen(true)} />
        <Modal
            title='财务改往来'
            open={open}
            onCancel={() => setOpen(false)}
            onOk={() => {
                updateSave({
                    ddsr_id:props.ddsr_id,
                    ddsr_zflx:info.ddsr_zflx,
                }).then((res) => {
                    if(res.data.Status === 'success') {
                        message.success('财务改往来成功！')
                        setOpen(false)
                    } else {
                        message.error('财务改往来失败！'+res.data.Message)
                    }
                }).catch((err) => {
                    message.error('财务改往来失败！'+err.message)
                })
            }}
        >
            <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
                <Form.Item label='往来类型' name='ddsr_zflx' rules={[{ required: true, message: '请选择往来类型' }]}>
                    <Radio.Group onChange={(e) => {
                        setInfo(prev => ({ ...prev, ddsr_zflx: e.target.value }))
                    }}>
                        <Radio value='现收'>现收</Radio>
                        <Radio value='应收'>应收</Radio>
                        <Radio value='核销应收'>核销应收</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Modal>
    </>
  )
}

export default IncomeFinanceZFLX